(() => {
  const init = scope => {
    const headers = scope.matches?.('[data-as-compact-header]') ? [scope] : Array.from(scope.querySelectorAll('[data-as-compact-header]'));
    headers.forEach(header => {
      if (header.dataset.asMenuReady) return;
      const open = header.querySelector('[data-as-menu-open]');
      const close = header.querySelector('[data-as-menu-close]');
      const dialog = header.querySelector('[data-as-menu-dialog]');
      if (!open || !close || !dialog) return;
      header.dataset.asMenuReady = 'true';
      let previousOverflow = '';
      open.addEventListener('click', () => {
        if (dialog.open) return;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        open.setAttribute('aria-expanded', 'true');
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        open.setAttribute('aria-expanded', 'false');
        open.focus({ preventScroll: true });
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(header) && dialog.open) dialog.close();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
